<div class="flex items-center justify-center dialog-header ">
    {{formAction}} Field
    <span *ngIf="isFixedField" class="ml-2 px-2 py-1 bg-orange-100 text-orange-800 text-xs font-semibold rounded">
        Fixed Field - Label Only
    </span>

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">

    <form #SaveleadForm="ngForm" class="space-y-4">
        <div class="grid grid-cols-1 gap-4">
            <div>
                <label class="block mb-2">Select Modules <span class="text-red-500">*</span></label>
                <p-multiselect 
                    class="w-full" 
                    appendTo="body" 
                    [options]="moduleOptions" 
                    [(ngModel)]="selectedModules" 
                    name="modules"
                    #modules="ngModel"
                    placeholder="Select Modules"
                    [disabled]="formAction === 'Edit' || isFixedField"
                    required
                    [ngClass]="{'ng-invalid ng-dirty': modules.invalid && isSubmitted}"
                    display="chip"
                ></p-multiselect>
                <small class="text-red-500" *ngIf="modules.errors && isSubmitted">
                    <span *ngIf="modules.errors['required']">Please select at least one module</span>
                </small>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block mb-2">Field Name</label>
                <input pInputText class="w-full" style="box-shadow: none !important;" required [(ngModel)]="leadsFeild.field_name"
                    name="field_name" #field_name="ngModel"
                    [ngClass]="{'ng-invalid ng-dirty': field_name.invalid && isSubmitted}"
                    [disabled]="isFixedField"
                    />
                <small class="text-red-500" *ngIf="field_name.errors && isSubmitted">
                    <span *ngIf="field_name.errors['required']">Field Name is required</span>
                </small>

                <small class="text-red-500" *ngIf="leadsFeild.field_name && isUniqueName(leadsFeild.field_name,formAction) == false">
                    Field name should be unique
                </small>
            </div>
            <div>
                <label class="block mb-2">Field Type</label>
                <p-select class="w-full" appendTo="body" [options]="fieldTypes" [(ngModel)]="leadsFeild.type" name="type"
                    #fieldType="ngModel" placeholder="Select Type"
                    required="true"
                    [ngClass]="{'ng-invalid ng-dirty': fieldType.invalid && isSubmitted}"
                    [disabled]="isFixedField"
                    ></p-select>

                <small class="text-red-500" *ngIf="fieldType.errors && isSubmitted">
                    <span *ngIf="fieldType.errors['required']">Field Type is required</span>
                </small>
            </div>
        </div>

        <div *ngIf="leadsFeild.type == 'select'" [ngClass]="{'opacity-50 pointer-events-none': isFixedField}">
            <label class="block mb-2">Select Options</label>
            <div class="flex flex-wrap gap-2 mt-1 mb-1">
                <span *ngFor="let item of leadsFeild.data; let ind=index">
                    <p-chip 
                    [removable]="!isFixedField" 
                    (onRemove)="removeOption(ind, 'add')">{{ item }}</p-chip>
                </span>
            </div>
            <input pInputText class="w-full mt-2" style="box-shadow: none !important;" [(ngModel)]="leadsFeild.options" name="options"
                (keyup.enter)="addOption(leadsFeild.options, 'add')" placeholder="Press Enter to add" [disabled]="isFixedField" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block mb-2">Field Label</label>
                <input pInputText class="w-full" style="box-shadow: none !important;" required [(ngModel)]="leadsFeild.label" name="label"
                    #fieldlabel="ngModel"
                    required="true"
                    [ngClass]="{'ng-invalid ng-dirty': fieldlabel.invalid && isSubmitted}"
                    />

                  <small class="text-red-500" *ngIf="fieldlabel.errors && isSubmitted">
                    <span *ngIf="fieldlabel.errors['required']">Field Label is required</span>
                  </small>  
            </div>
            <div>
                <label class="block mb-2">Required</label>
                <p-select class="w-full" appendTo="body" [options]="booleanOptions" [(ngModel)]="leadsFeild.required"
                    name="required"
                    [disabled]="isFixedField"
                    ></p-select>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block mb-2">Placeholder</label>
                <input pInputText class="w-full" style="box-shadow: none !important;" [(ngModel)]="leadsFeild.placeholder" name="placeholder" [disabled]="isFixedField" />
            </div>
            <div>
                <label class="block mb-2">Sequence</label>
                <input pInputText type="number" class="w-full" style="box-shadow: none !important;" [(ngModel)]="leadsFeild.sequence" name="sequence" [disabled]="isFixedField" />
            </div>
        </div>

        <!-- min length and maxLength -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="leadsFeild.type !== 'select'">
            <div>
                <label class="block mb-2">Min Length</label>
                <input pInputText type="number" class="w-full" style="box-shadow: none !important;" [(ngModel)]="leadsFeild.min_length" name="min_length" [disabled]="isFixedField" />
            </div>
            <div>
                <label class="block mb-2">Max Length</label>
                <input pInputText type="number" class="w-full" style="box-shadow: none !important;" [(ngModel)]="leadsFeild.max_length" name="max_length" [disabled]="isFixedField" />
            </div>
        </div>

        <!-- is email is many -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block mb-2">Is Email</label>
                <p-select class="w-full" appendTo="body" [options]="booleanOptions" [(ngModel)]="leadsFeild.is_email" name="is_email"
                    [disabled]="isFixedField"
                    ></p-select>
            </div>
            <!-- <div>
                <label class="block mb-2">Is Many</label>
                <p-select class="w-full" appendTo="body" [options]="booleanOptions" [(ngModel)]="leadsFeild.is_many" name="is_many"
                    [disabled]="isFixedField"
                    ></p-select>
            </div> -->
              <div>
                <label class="block mb-2">Visible In Table</label>
                <p-select class="w-full" appendTo="body" [options]="booleanOptions" [(ngModel)]="leadsFeild.visible_in_table"
                    name="visible_in_table"
                    [disabled]="isFixedField"
                    ></p-select>
            </div>
        </div>

        <!-- is public and visible in table -->
        <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4"> -->
            <!-- <div>
                <label class="block mb-2">Is Public</label>
                <p-select class="w-full" appendTo="body" [options]="booleanOptions" [(ngModel)]="leadsFeild.is_public" name="is_public"
                    [disabled]="isFixedField"
                    ></p-select>
            </div> -->
          
        <!-- </div> -->



        <div class="flex justify-end space-x-2" >

            <p-button type="button" label="Cancel" 
            variant="outlined"
            severity="danger"
           (click)="handleCloseDialog()"></p-button>

            <p-button  (click)="SaveLead(SaveleadForm.form.valid)"
                [disabled]="btnLoading"
                [loading]="btnLoading"
                icon="pi pi-save" 
                label="Save">
            </p-button>
        </div>
    </form>


</div>